export default (Vue, {appConfig}) => {

  const utils = {

    /**
     * Get generale app informations.
     * @return {Object} appConfig
     */
    getAppInfo() {
      return appConfig;
    },


    /**
     * Create new invite in webapp.
     *
     * @param {Array} tags
     * @param {Object} opt_metaData
     */
    createInvite(tags, opt_metaData) {
      if (!Vue.store.getters['session/isLoggedIn']) {
        throw new TypeError('You have to loggedin a user at first to create a new invitation');
      }

      const component = document.getElementById('invite');
      component.__vue__.open(tags, opt_metaData);
    },


    /**
     * Trigger an invite user call.
     *
     * @param {string} inviteId
     * @param {Object} user
     */
    invitation(inviteId, user) {
      if (!inviteId) {
        throw new TypeError('Missing inviteId');
      }
      if (!user) {
        throw new TypeError('Missing user object');
      }

      const referrer = Object.assign({}, {
        type: 'invitation',
        data: {inviteId, user}
      });

      Vue.store.dispatch('setReferrer', referrer);
      Vue.store.dispatch('invitation', inviteId);
    }
  };

  Vue.utils = utils;

  return utils;
};
